import { render, staticRenderFns } from "./kucun.vue?vue&type=template&id=1a8de69c"
import script from "./kucun.vue?vue&type=script&lang=js"
export * from "./kucun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports